export const getConfigurationsUpdated = (reference, current) => {
  if (!reference || !current) {
    return {};
  }

  return Object.entries(current).reduce((acc, [key, value]) => {
    if (value.value !== reference[key].value) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const validateConfigurations = (configurations) => {
  let valid = true;

  // Validate offline mode configuration
  if (configurations?.offlineModeEnabled?.value) {
    if (!Number(configurations?.offlineModeDuration?.value) > 0) {
      valid = false;
    }
  }

  return valid;
};
